<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <ClientFormAutocomplete
          v-model="form.company_name"
          @selected="populateForm"
          label="Ime podjetja *"
        ></ClientFormAutocomplete>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.company_name.required)"
        >
          <FormErrorsLine v-if="!$v.form.company_name.required" text="Polje je obvezno" />
        </FormErrors>
        <ClientFormAutocomplete
          v-model="form.company_address"
          @selected="populateForm"
          label="Ulica in hišna številka podjetja *"
        ></ClientFormAutocomplete>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.company_address.required)"
        >
          <FormErrorsLine v-if="!$v.form.company_address.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.company_post_code"
          label="Poštna številka podjetja *"
          @blur="fillCompanyCity"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.company_post_code.required)"
        >
          <FormErrorsLine v-if="!$v.form.company_post_code.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.company_city"
          label="Mesto podjetja *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.company_city.required)"
        >
          <FormErrorsLine v-if="!$v.form.company_city.required" text="Polje je obvezno" />
        </FormErrors>
        <v-checkbox
          color="#0F998E"
          v-model="form.company_tax_bound"
          label="Zavezanec za ddv"
        ></v-checkbox>
        <ClientFormAutocomplete
          v-model="form.company_tax_number"
          @selected="populateForm"
          label="Davčna številka podjetja *"
        ></ClientFormAutocomplete>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.company_tax_number.required || !$v.form.company_tax_number.isTaxNumber)"
        >
          <FormErrorsLine v-if="!$v.form.company_tax_number.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.company_tax_number.isTaxNumber" text="Davčna številka ni veljavna" />
        </FormErrors>
        <ClientFormAutocomplete
          v-model="form.company_register_number"
          @selected="populateForm"
          label="Matična številka podjetja"
        ></ClientFormAutocomplete>
        <v-text-field
          v-model="form.company_account_number"
          label="Številka računa podjetja"
        ></v-text-field>
        <v-text-field
          v-model="form.company_contact"
          label="Kontakt"
        ></v-text-field>
        <v-text-field
          v-model="form.username"
          label="Uporabniško ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.username.required)"
        >
          <FormErrorsLine v-if="!$v.form.username.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.password"
          type="password"
          label="Geslo *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.password.required || !$v.form.password.alphaNum || !$v.form.password.minLength || !$v.form.password.maxLength)"
        >
          <FormErrorsLine v-if="!$v.form.password.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.password.alphaNum" text="Dovoljene so le male črke, velike črke in številke" />
          <FormErrorsLine v-if="!$v.form.password.minLength || !$v.form.password.maxLength" text="Dolžina gesla mora biti med 6 in 20 znakov" />
        </FormErrors>
        <v-text-field
          v-model="form.password2"
          type="password"
          label="Geslo, ponovno *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.password2.required || !$v.form.password2.alphaNum || !$v.form.password2.minLength || !$v.form.password2.maxLength || !$v.form.password2.sameAsPassword)"
        >
          <FormErrorsLine v-if="!$v.form.password2.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.password2.alphaNum" text="Dovoljene so le male črke, velike črke in številke" />
          <FormErrorsLine v-if="!$v.form.password2.minLength || !$v.form.password2.maxLength" text="Dolžina gesla mora biti med 6 in 20 znakov" />
          <FormErrorsLine v-if="!$v.form.password2.sameAsPassword" text="Gesli se ne ujemata" />
        </FormErrors>
        <v-text-field
          v-model="form.pin_code"
          type="password"
          label="Pin"
        ></v-text-field>
        <v-text-field
          v-model="form.pin_code2"
          type="password"
          label="Pin, ponovno"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && !$v.form.pin_code2.sameAsPin"
        >
          <FormErrorsLine v-if="!$v.form.pin_code2.sameAsPin" text="Pin kodi se ne ujemata" />
        </FormErrors>
        <v-text-field
          v-model="form.complete_name"
          label="Ime in priimek"
        ></v-text-field>
        <v-text-field
          v-model="form.moniker"
          label="Oznaka blagajnika"
        ></v-text-field>
        <v-text-field
          v-model="form.tax_number"
          label="Davčna številka"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.tax_number.required || !$v.form.tax_number.isTaxNumber)"
        >
          <FormErrorsLine v-if="!$v.form.tax_number.isTaxNumber" text="Davčna številka ni veljavna" />
        </FormErrors>
        <v-text-field
          v-model="form.address"
          label="Ulica in hišna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.post_code"
          label="Poštna številka"
          @blur="fillCity"
        ></v-text-field>
        <v-text-field
          v-model="form.city"
          label="Mesto"
        ></v-text-field>
        <v-text-field
          v-model="form.phone"
          label="Telefon"
        ></v-text-field>

        <v-select
          v-if="this.companyType === 1"
          :items="sourceCompaniesWithNull"
          item-text="name"
          item-value="val"
          v-model="form.source_company"
          label="Kopiraj podatke od"
        ></v-select>

        <v-btn type="submit" class="float-right">Ustvari</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required, minLength, maxLength, alphaNum, sameAs } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ClientFormAutocomplete from '@/components/ClientFormAutocomplete'
import { postName } from '@/utils/postCodes'
import { isValidTaxNumber } from '@/utils/taxNumber'
import { mapActions } from 'vuex'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ClientFormAutocomplete
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    companyType: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      noDefaults: false,
      sourceCompaniesWithNull: [],
      emptyForm: {
        company_name: '',
        company_address: '',
        company_post_code: '',
        company_city: '',
        company_tax_bound: false,
        company_tax_number: '',
        company_register_number: '',
        company_account_number: '',
        company_contact: '',
        company_type: null,
        username: '',
        password: '',
        password2: '',
        pin_code: '',
        pin_code2: '',
        complete_name: '',
        moniker: '',
        tax_number: '',
        address: '',
        post_code: '',
        city: '',
        phone: '',
        source_company: null
      },
      form: {
        company_name: '',
        company_address: '',
        company_tax_number: '',
        company_register_number: ''
      }
    }
  },
  validations: {
    form: {
      company_name: {
        required
      },
      company_address: {
        required
      },
      company_post_code: {
        required
      },
      company_city: {
        required
      },
      company_tax_number: {
        required,
        isTaxNumber: val => isValidTaxNumber(val)
      },
      username: {
        required
      },
      password: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      password2: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20),
        sameAsPassword: sameAs('password')
      },
      pin_code2: {
        sameAsPin: sameAs('pin_code')
      },
      tax_number: {
        isTaxNumber: val => isValidTaxNumber(val) || val === '' || val === null
      }
    }
  },
  computed: {
    sourceCompanies () {
      const companies = Object.values(this.$store.state.companies.childCompanies)
      return companies.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
    }
  },
  created () {
    this.form = { ...this.emptyForm }
    this.form.company_type = this.companyType
    this.createDefaults = !this.canAddCompany
    this.loadChildCompanies()
      .then(response => {
        this.sourceCompaniesWithNull.push({
          name: 'Ne kopiraj šifrantov',
          val: null
        })
        this.sourceCompanies.forEach(unit => {
          this.sourceCompaniesWithNull.push({
            name: `${unit.name}`,
            val: unit.id
          })
        })
      })
  },
  methods: {
    ...mapActions('companies', ['loadChildCompanies']),
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.form.company_type = this.companyType
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    },
    populateForm (companyData) {
      this.form.company_name = companyData.name ? companyData.name : ''
      this.form.company_address = companyData.address ? companyData.address : ''
      this.form.company_post_code = companyData.post_code ? companyData.post_code : ''
      this.form.company_city = companyData.city ? companyData.city : ''
      this.form.company_tax_bound = companyData.tax_bound ? companyData.tax_bound : false
      this.form.company_tax_number = companyData.tax_number ? companyData.tax_number : ''
      this.form.company_register_number = companyData.register_number ? companyData.register_number : ''
      this.form.company_account_number = companyData.account_number ? companyData.account_number : ''
    },
    fillCompanyCity () {
      this.form.company_city = postName(this.form.company_post_code)
    },
    fillCity () {
      this.form.city = postName(this.form.post_code)
    }
  }
}
</script>
